import React from "react";
import { PageSeo } from "@/components/seo/PageSeo";
import { FracLogoLight } from "@/components/brand/FracLogo";
import { Button } from "@/components/ui/Button";
import { ArrowLeft } from "lucide-react";
import { useT } from "@/hooks/useT";
import { useLocale } from "@/hooks/useLocale";
import { addLocalePrefix } from "@/lib/locale";

export default function NotFound() {
  const { t } = useT("notFound");
  const locale = useLocale();
  return (
    <>
      <PageSeo
        title={t("seoTitle")}
        description={t("seoDescription")}
        path="/404"
      />
      <section
        className="container-frac flex min-h-[calc(100vh-72px)] flex-col items-start justify-center py-24"
        data-testid="page-notfound"
      >
        <FracLogoLight size="lg" markOnly data-testid="notfound-mark" />
        {/* TODO Phase 4: 3D easter egg */}
        <div
          className="mt-10 text-[120px] font-light leading-none tracking-tight text-frac-violet sm:text-[180px]"
          data-testid="notfound-numeral"
        >
          404
        </div>
        <h1
          className="mt-8 text-3xl font-bold leading-tight tracking-tight text-ink-primary sm:text-4xl"
          data-testid="page-h1"
        >
          {t("h1")}
        </h1>
        <p className="mt-4 max-w-xl text-base text-ink-secondary">{t("sub")}</p>
        <Button
          as="link"
          to={addLocalePrefix("/", locale)}
          variant="primary-on-dark"
          size="lg"
          className="mt-10"
          data-testid="notfound-home-button"
        >
          <ArrowLeft className="h-4 w-4" strokeWidth={1.75} />
          {t("cta")}
        </Button>
      </section>
    </>
  );
}
